"use strict"

module.exports = function signum(x) {
  if(x < 0) { return -1 }
  if(x > 0) { return 1 }
  return 0.0
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/signum/sgn.js
// module id = m/hr
// module chunks = 0